/**
 * R5 — Persistance de la baseline du sondage Ifop dans localStorage.
 *
 * J2 — pour que la variation par CSP du sondage suivant ne soit pas
 * toujours zéro, on fige l'état du monde au moment où le joueur ferme
 * un sondage. Survit au refresh.
 */

import type { WorldState } from "../engine/types";

export const POLL_BASELINE_KEY = "mp.lastPollBaseline";

export function loadPollBaseline(): WorldState | null {
  try {
    const raw = localStorage.getItem(POLL_BASELINE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as WorldState;
  } catch {
    return null;
  }
}

export function persistPollBaseline(state: WorldState | null): void {
  try {
    if (state) {
      localStorage.setItem(POLL_BASELINE_KEY, JSON.stringify(state));
    } else {
      localStorage.removeItem(POLL_BASELINE_KEY);
    }
  } catch {
    /* quota / private mode — ignoré */
  }
}
